import { useState, useEffect } from "react";
import { BarChart3, Mic, Clock, Zap, TrendingUp, User, DollarSign, FileText, Calendar, Radio, Music, Cpu } from "lucide-react";
import { BACKEND_URL } from "../../context/AuthContext";

export const AIInsights = ({ authToken }) => {
  const [insights, setInsights] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchInsights(); }, []);

  const fetchInsights = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/ai/insights`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      if (res.ok) setInsights(await res.json());
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  if (loading) return <div className="text-center py-12"><div className="w-6 h-6 border-2 border-white/20 border-t-cyan-500 rounded-full animate-spin mx-auto" /></div>;

  const cards = [
    { icon: Mic, label: "Podcasts Generated", value: insights?.podcasts_generated || 0, color: "text-violet-400", bg: "from-violet-500/15 to-fuchsia-500/15", border: "border-violet-500/20" },
    { icon: Clock, label: "Minutes Produced", value: `${insights?.minutes_produced || 0} min`, color: "text-cyan-400", bg: "from-cyan-500/15 to-blue-500/15", border: "border-cyan-500/20" },
    { icon: Zap, label: "Estimated Time Saved", value: `${insights?.estimated_time_saved_hours || 0}h`, color: "text-amber-400", bg: "from-amber-500/15 to-orange-500/15", border: "border-amber-500/20" },
    { icon: TrendingUp, label: "Avg Generation Time", value: `${insights?.average_generation_time_seconds || 0}s`, color: "text-emerald-400", bg: "from-emerald-500/15 to-teal-500/15", border: "border-emerald-500/20" },
    { icon: BarChart3, label: "Success Rate", value: `${insights?.success_rate || 0}%`, color: "text-green-400", bg: "from-green-500/15 to-emerald-500/15", border: "border-green-500/20" },
    { icon: User, label: "Most Used Voice", value: insights?.most_used_voice || "N/A", color: "text-pink-400", bg: "from-pink-500/15 to-rose-500/15", border: "border-pink-500/20" },
    { icon: FileText, label: "Most Used Template", value: insights?.most_used_template || "N/A", color: "text-indigo-400", bg: "from-indigo-500/15 to-purple-500/15", border: "border-indigo-500/20" },
    { icon: DollarSign, label: "Est. Monthly Cost", value: `$${insights?.estimated_monthly_cost || 0}`, color: "text-sky-400", bg: "from-sky-500/15 to-cyan-500/15", border: "border-sky-500/20" },
    { icon: Calendar, label: "Broadcasts Scheduled", value: insights?.broadcasts_scheduled || 0, color: "text-cyan-400", bg: "from-cyan-500/15 to-teal-500/15", border: "border-cyan-500/20" },
    { icon: Radio, label: "Host Generations", value: insights?.host_generations || 0, color: "text-fuchsia-400", bg: "from-fuchsia-500/15 to-pink-500/15", border: "border-fuchsia-500/20" },
    { icon: Music, label: "Playlist Queries", value: insights?.playlist_queries || 0, color: "text-emerald-400", bg: "from-emerald-500/15 to-green-500/15", border: "border-emerald-500/20" },
    { icon: Cpu, label: "Providers Used", value: insights?.provider_usage?.length || 0, color: "text-blue-400", bg: "from-blue-500/15 to-indigo-500/15", border: "border-blue-500/20" },
  ];

  return (
    <div data-testid="ai-insights">
      <h3 className="text-lg font-semibold text-white flex items-center gap-2 mb-4">
        <BarChart3 className="w-5 h-5 text-cyan-400" /> AI Insights
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {cards.map(c => (
          <div key={c.label} className={`bg-gradient-to-br ${c.bg} border ${c.border} rounded-2xl p-4`} data-testid={`insight-${c.label.toLowerCase().replace(/\s/g, "-")}`}>
            <c.icon className={`w-5 h-5 ${c.color} mb-2`} />
            <p className="text-white font-bold text-lg">{c.value}</p>
            <p className="text-white/40 text-xs">{c.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
